<div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1100;">
  @for (toast of notificationService.toasts(); track toast.id) {
    <div [class]="'toast show align-items-center text-white bg-' + toast.type + ' border-0 mb-2'" role="alert" aria-live="assertive" aria-atomic="true">
      <div class="d-flex">
        <div class="toast-body">
          @if (toast.title) {
            <h6 class="text-white mb-1 fw-bold">{{ toast.title }}</h6>
          }
          <div>{{ toast.message }}</div>
        </div>
        <button type="button" class="btn-close btn-close-white me-2 m-auto" (click)="notificationService.removeToast(toast.id)"></button>
      </div>
    </div>
  }
</div>
